import React from "react";
import { Link } from "react-router-dom";
import { Badge, Box, Flex, Text } from "@telia/teddy";
import { type FeedbackEntry } from "../SuperAdmin/feedbackTypes";
import PAGES from "../../../../../constants/pages";

const LABEL_VARIANT: Record<string, "special" | "error" | "information" | "success"> = {
    review: "special",
    Bug: "error",
    "Generell tilbakemelding": "information",
    "Forslag til forbedring": "success",
};

const FEEDBACK_TYPE_LABELS: Record<string, string> = {
    review: "Vurdering",
    Bug: "Bug",
    "Generell tilbakemelding": "Generell tilbakemelding",
    "Forslag til forbedring": "Forslag til forbedring",
};

const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric" });

type FeedbackCardProps = {
    shouldShowName: boolean;
    entry: FeedbackEntry;
};

const FeedbackCard: React.FC<FeedbackCardProps> = ({ entry, shouldShowName }) => {
    return (
        <Link to={`${PAGES.RETAILER.FEEDBACK_DETAILS.URL}${entry.id}`} className="user-feedback-card">
            <Flex direction="row" className="user-feedback-card__header" gap="200" wrap="wrap">
                <Flex gap="200" align="center">
                    <Badge variant={LABEL_VARIANT[entry.feedbackType] ?? "information"}>
                        {FEEDBACK_TYPE_LABELS[entry.feedbackType] ?? entry.feedbackType}
                    </Badge>
                    {shouldShowName && entry.agentName && (
                        <Text className="user-feedback-card__agent">
                            {entry.agentName} • {entry.dealerName}
                        </Text>
                    )}
                </Flex>
                <Text className="user-feedback-card__date">{formatDate(entry.createdAt)}</Text>
            </Flex>
            {entry.description && (
                <Box className="user-feedback-card__description">
                    <Text className="user-feedback-card__description-text">{entry.description}</Text>
                </Box>
            )}
        </Link>
    );
};

export default FeedbackCard;
